export default __webpack_public_path__ + "static/media/robot-avatar.e19491c9.svg";